import React from 'react';

import { FormattedMessage } from 'react-intl';

import messages from './messages';

const dateFilterOperators = {
  dateToday: 'dateToday',
  dateYesterday: 'dateYesterday',
  dateLastWeek: 'dateLastWeek',
  dateLast30Days: 'dateLast30Days',
  dateThisMonth: 'dateThisMonth',
  dateLastMonth: 'dateLastMonth',
  dateCustomRange: 'dateCustomRange',
};

const DateRangeOptions = [
  {
    id: dateFilterOperators.dateToday,
    descriptor: messages.dateToday,
    displayName: <FormattedMessage {...messages.dateToday} />,
    value: dateFilterOperators.dateToday,
  },
  {
    id: dateFilterOperators.dateYesterday,
    descriptor: messages.dateYesterday,
    displayName: <FormattedMessage {...messages.dateYesterday} />,
    value: dateFilterOperators.dateYesterday,
  },
  {
    id: dateFilterOperators.dateLastWeek,
    descriptor: messages.dateLastWeek,
    displayName: <FormattedMessage {...messages.dateLastWeek} />,
    value: dateFilterOperators.dateLastWeek,
  },
  {
    id: dateFilterOperators.dateLast30Days,
    descriptor: messages.dateLast30Days,
    displayName: <FormattedMessage {...messages.dateLast30Days} />,
    value: dateFilterOperators.dateLast30Days,
  },
  {
    id: dateFilterOperators.dateThisMonth,
    descriptor: messages.dateThisMonth,
    displayName: <FormattedMessage {...messages.dateThisMonth} />,
    value: dateFilterOperators.dateThisMonth,
  },
  {
    id: dateFilterOperators.dateLastMonth,
    descriptor: messages.dateLastMonth,
    displayName: <FormattedMessage {...messages.dateLastMonth} />,
    value: dateFilterOperators.dateLastMonth,
  },
  {
    id: dateFilterOperators.dateCustomRange,
    descriptor: messages.dateCustomRange,
    displayName: <FormattedMessage {...messages.dateCustomRange} />,
    value: dateFilterOperators.dateCustomRange,
  },
];

export default DateRangeOptions;

export const customDateRangeOption = DateRangeOptions.find((option) => option.id === dateFilterOperators.dateCustomRange);
